const overrideLog = (store) => {
    const { dispatch } = store;
  
    const o_log = console.log;
    const o_error = console.error;

    console.log = (...args) => {
      dispatch("appendLog", {
        log: JSON.stringify(args.join(" ")),
      });

      o_log(...args);
    };

    console.error = (...args) => {
      dispatch("appendLog", {
        log: "ERROR: " + JSON.stringify(args.join(" ")),
      });

      o_error(...args);
    };
}

export {overrideLog}